import { Common } from '~/models/common';
import { Services } from '~/models/services';
import { ServicesGroup } from '~/models/services-group';

export const servicesService = {
	fetch: async (): Promise<Services.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
			fields: [
				'*',
				'preview.*',
				'seo.title',
				'seo.header',
				'seo.keywords',
				'seo.description',
				'group.services_group_id.id',
				'form.*',
			],
		};

		try {
			const response = await $fetch<
				(Omit<Services.Model, 'group'> & {
					group: { services_group_id: { id: number } }[];
				})[]
			>(Services.api, {
				method: 'POST',
				body: { params },
			});

			/** Resolve services group */
			const servicesList = response.reduce((acc, service) => {
				const group = service.group.map(g => g.services_group_id.id);

				acc.push({ ...service, group });
				return acc;
			}, [] as Services.Model[]);

			return servicesList;
		} catch (error) {
			console.error('Failed to fetch Services:', error);

			return [];
		}
	},

	fetchGroup: async (): Promise<ServicesGroup.Model[]> => {
		const params = {
			filter: {
				pageView: true,
				status: Common.Status.PUBLISHED,
			},
			fields: ['*'],
		};

		try {
			const response = await $fetch<ServicesGroup.Model[]>(ServicesGroup.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch ServicesGroup:', error);

			return [];
		}
	},

	getItem: async (alias: string): Promise<Services.Model | undefined> => {
		const params = {
			filter: {
				alias: alias,
				status: Common.Status.PUBLISHED,
			},
			fields: [
				'*',
				'preview.*',
				'seo.title',
				'seo.header',
				'seo.keywords',
				'seo.description',
				'group.services_group_id.id',
				'form.*',
			],
		};

		try {
			const [response] = await $fetch<[Services.Model]>(Services.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Services:', error);

			return undefined;
		}
	},
};
